import { NavigationUserOnPaytmMembershipPlan } from './paytm.model';

export function transformNavigationUserOnPaytmMembershipPlan(
  value: NavigationUserOnPaytmMembershipPlan,
) {
  return value;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/datastore/navigation/paytm/paytm.transformers.ts